import {tns} from 'tiny-slider/src/tiny-slider'

export function initSlider() {
  if (!document.querySelector('.js-sell-auto-slider')) return

  tns({
    container: '.js-sell-auto-slider',
    items: 2,
    nav: false,
    controlsContainer: '.js-sell-auto-slider-controls',
    loop: false,
    gutter: 20,
    responsive: {
      640: {
        items: 4,
      }
    },
  })
}
